var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_607_1231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 6.125C23.8125 8.65812 21.7519 10.7188 19.2188 10.7188C16.6856 10.7188 14.625 8.65812 14.625 6.125C14.625 3.59188 16.6856 1.53125 19.2188 1.53125C21.7519 1.53125 23.8125 3.59188 23.8125 6.125ZM21.1875 13.0681C20.5312 13.2387 19.875 13.3438 19.2188 13.3438C15.2419 13.3438 12 10.1019 12 6.125C12 4.19562 12.7612 2.45 13.9688 1.15063C13.5094 0.58625 12.8006 0.21875 12 0.21875C10.5562 0.21875 9.375 1.4 9.375 2.84375V3.22437C5.47687 4.37937 2.8125 7.9625 2.8125 12.0312V19.9062L0.1875 22.5312V23.8438H23.8125V22.5312L21.1875 19.9062V13.0681ZM12 27.7812C13.4569 27.7812 14.625 26.6131 14.625 25.1562H9.375C9.375 26.6131 10.5562 27.7812 12 27.7812Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_607_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0894 5.92139C24.0894 8.45451 22.0287 10.5151 19.4956 10.5151C16.9625 10.5151 14.9019 8.45451 14.9019 5.92139C14.9019 3.38826 16.9625 1.32764 19.4956 1.32764C22.0287 1.32764 24.0894 3.38826 24.0894 5.92139ZM21.4644 12.8645C20.8081 13.0351 20.1519 13.1401 19.4956 13.1401C15.5187 13.1401 12.2769 9.89826 12.2769 5.92139C12.2769 3.99201 13.0381 2.24639 14.2456 0.947012C13.7862 0.382637 13.0775 0.0151367 12.2769 0.0151367C10.8331 0.0151367 9.65186 1.19639 9.65186 2.64014V3.02076C5.75373 4.17576 3.08936 7.75889 3.08936 11.8276V19.7026L0.464355 22.3276V23.6401H24.0894V22.3276L21.4644 19.7026V12.8645ZM12.2769 27.5776C13.7337 27.5776 14.9019 26.4095 14.9019 24.9526H9.65186C9.65186 26.4095 10.8331 27.5776 12.2769 27.5776Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8394,
    cy: 6.57764,
    r: 5.25,
    fill: "#B73D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithnot);
export default __webpack_public_path__ + "static/media/with not.4c505afaa23de21b21827d3fb114a419.svg";
export { ForwardRef as ReactComponent };